import GlobalConfig from '@/global/config'
import { getSurveyStatusInfoH } from '@/api/layout/survey-layout/top-header'
import { mapState } from 'vuex'

export const surveyVersionMixin = {
  data() {
    return {
      releaseVersionId: null,
    }
  },
  computed:{
    ...mapState({
      versionId: state => state.survey.versionId
    }),
  },
  watch:{
    versionId(){
      this.getCurrentSurveyVersion()
    }
  },
  created() {
    this.getCurrentSurveyVersion()
  },
  methods: {
    getCurrentSurveyVersion() {
      getSurveyStatusInfoH({ surveyId: GlobalConfig.getSurveyId() }).then(res => {
        this.releaseVersionId = res.data.data.releaseVersionId
      })
    }
  }
}
